export default __webpack_public_path__ + "static/media/logo-black.74d44e2e.png";